export { default } from './containers/Mam2';
export * from './modules/actions';
export * from './modules/reducer';
export * from './modules/selectors';
